export default (set, get, data) => {
  set(
    () => {
      const currentSearchProducts = get().collection.searchProducts || {}; // Handle initial undefined state

      return {
        ...get(),
        collection: {
          ...get().collection,
          ...data,
          choiceBasedProducts: {
            ...get().collection.choiceBasedProducts,
            ...data.choiceBasedProducts,
          },
          searchModelSKus: {
            ...get().collection.searchModelSKus,
            ...data.searchModelSKus,
          },
          fetchedCategories: {
            ...get().collection.fetchedCategories,
            ...data.fetchedCategories,
          },
          fetchedCachedData: {
            ...get().collection.fetchedCachedData,
            ...data.fetchedCachedData,
          },
          searchProducts: {
            ...currentSearchProducts, // Merge with existing searchProducts
            ...data.searchProducts, // Add/overwrite with new data
          },
        },
        isSkusFetched: data.isSkusFetched || false,
        fetchedItemIdsByChoice: {
          ...get().fetchedItemIdsByChoice,
          ...(data.fetchedItemIds ? { [data.choiceId]: data.fetchedItemIds } : {}),
        },
        isLoading: data.isLoading === undefined ? get().isLoading : data.isLoading,
      };
    },
    false,
    { type: 'collection/updateCollection', data }
  );
};